
import * as __star__ from '@clayui/data-provider';

const {
default: __default__,
DataProvider,
useResource,
__esModule
} = __star__;

export {
DataProvider,
useResource,
__esModule
};
export default __default__;
